export const formatNumber = value => {
    return Number(Math.ceil(value)).toLocaleString();
};